import React from "react";

const projectsPerPage = 3;
const Banner_News_Updates = ({ Bannerdata }) => {
  const screen = Bannerdata.screenbanner;
  const mobile = Bannerdata.mobilebanner;
  
  return (
    <div className="relative w-full h-[200px] h800:h-[200px] lgDesktop:h-[300px]  mt-[3%]">
      {/* Desktop Banner */}
      <div
        className="hidden lg:block absolute inset-0 bg-cover bg-center "
        style={{ backgroundImage: `url(${screen})` }}
      />

      {/* Mobile Banner */}
      <div
        className="lg:hidden absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${mobile})` }}
      />

      {/* Text Overlay */}
      {/* <div className="">
    <h2 className=" w-[65%] absolute inset-0 flex items-center justify-center text-white text-3xl sm:text-4xl md:text-5xl font-bold z-10 px-4">
        {tagline}
    </h2>
    </div> */}
    </div>
  );
};

export default Banner_News_Updates;
